<template>
  <head>

    <meta charset="utf-8" />
    <title>Zone Performance Report | County Management System</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Revenue System" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">Zone Performance Report</h4>
                  <p class="text-muted mb-0">{{formatSubCountyName(subCountyName)}} • Period: {{formatDate(dateFrom)}} to {{formatDate(dateTo)}}</p>
                </div>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Reports</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Revenue by Sub County</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">{{formatSubCountyName(subCountyName)}}</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)">Collection Zones</a></li>
                    <li class="breadcrumb-item active">{{formatZoneName(zone)}}</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Zone Summary Card -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="card bg-info text-white">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-md-8">
                      <div class="d-flex align-items-center">
                        <div class="avatar-lg me-3">
                                                    <span class="avatar-title rounded-circle bg-white text-info fs-4 fw-bold">
                                                        {{getZoneInitials(zone)}}
                                                    </span>
                        </div>
                        <div>
                          <h3 class="text-white mb-1">{{formatZoneName(zone)}}</h3>
                          <p class="text-white-50 mb-0">
                            <i class="bx bx-map me-1"></i> {{formatSubCountyName(subCountyName)}}
                            <span class="mx-2">•</span>
                            <i class="bx bx-map-pin me-1"></i> Collection Zone
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4 text-end">
                      <div class="zone-selector">
                        <label class="form-label text-white-50 mb-2">Switch Zone</label>
                        <select class="form-select" v-model="zone">
                          <option v-for="(item, index) in zones" :value="item.zone" :key="index">
                            {{item.zone}} ({{numberFormat(item.count)}} transactions)
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Performance Summary Cards -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Collection</span>
                      <h4 class="mb-3">
                        <span class="counter-value text-success">KES {{numberFormat(totalAmount)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-success">
                                                <span class="avatar-title rounded-circle bg-success">
                                                    <i class="bx bx-money font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Total Transactions</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{numberFormat(billDetails.length)}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-primary">
                                                <span class="avatar-title rounded-circle bg-primary">
                                                    <i class="bx bx-receipt font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Active Agents</span>
                      <h4 class="mb-3">
                        <span class="counter-value">{{getActiveAgents().length}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-warning">
                                                <span class="avatar-title rounded-circle bg-warning">
                                                    <i class="bx bx-user font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6">
              <div class="card card-h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <span class="text-muted mb-3 lh-1 d-block text-truncate">Average per Transaction</span>
                      <h4 class="mb-3">
                        <span class="counter-value">KES {{getAverageTransaction()}}</span>
                      </h4>
                    </div>
                    <div class="flex-shrink-0">
                      <div class="avatar-sm rounded-circle bg-info">
                                                <span class="avatar-title rounded-circle bg-info">
                                                    <i class="bx bx-trending-up font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Transaction Table -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <h5 class="card-title mb-0">Zone Transaction History</h5>
                      <small class="text-muted">Showing {{billDetails.length}} of {{numberFormat(totalItems)}} transactions for {{formatZoneName(zone)}}</small>
                    </div>
                    <div class="col-md-6">
                      <div class="d-flex justify-content-end gap-2">
                        <button @click="refreshData()" type="button" class="btn btn-outline-primary btn-sm" :disabled="loading">
                          <i class="bx bx-refresh" :class="{'bx-spin': loading}"></i>
                          {{ loading ? 'Refreshing...' : 'Refresh' }}
                        </button>
                        <button v-if="getRight('DOWNLOAD REPORTS')" @click="downloadReceiptsPaginated()" type="button" class="btn btn-success btn-sm" :disabled="downloading">
                          <i class="bx bx-download"></i> {{downloadText}}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="searchTerm" type="text" class="form-control" placeholder="Search transactions..." />
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="d-flex justify-content-end gap-2">
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">From:</label>
                          <input v-model="dateFrom" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                        <div class="d-flex align-items-center">
                          <label class="form-label mb-0 me-2">To:</label>
                          <input v-model="dateTo" class="form-control form-control-sm" type="date" style="width: auto;">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body p-0">
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <h5>Loading Zone Data...</h5>
                    <p class="text-muted">Please wait while we fetch {{formatZoneName(zone)}}'s transaction history.</p>
                  </div>

                  <div v-else-if="billDetails.length === 0" class="text-center py-5">
                    <div class="py-4">
                      <i class="bx bx-map-pin font-size-96 text-muted"></i>
                      <h4 class="mt-3">No Transactions Found</h4>
                      <p class="text-muted">No transactions found for {{formatZoneName(zone)}} in the selected period.</p>
                      <button @click="clearFilters()" class="btn btn-outline-primary">Clear Filters</button>
                    </div>
                  </div>

                  <div v-else class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="table-dark">
                      <tr>
                        <th style="width: 150px;">Receipt No.</th>
                        <th>Paid By</th>
                        <th style="width: 120px;">Date</th>
                        <th style="width: 120px;">Payment Method</th>
                        <th>Payment Details</th>
                        <th>Served By</th>
                        <th style="width: 100px;">Status</th>
                        <th class="text-end" style="width: 130px;">Amount</th>
                        <th class="text-center" style="width: 120px;">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr :key="index" :value="item" v-for="(item, index) in billDetails">
                        <td>
                          <div class="d-flex align-items-center">
                            <span class="badge bg-light text-dark me-2">{{getItemNumber(index)}}</span>
                            <div>
                              <strong class="text-primary">{{item.transactionCode}}</strong>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="fw-medium">{{item.paidBy}}</span>
                            <br>
                            <small class="text-muted">{{maskPhoneNumber(item.customerPhoneNumber)}}</small>
                          </div>
                        </td>
                        <td>
                          <span class="text-nowrap">{{formatDate(item.dateCreated)}}</span>
                        </td>
                        <td>
                                                    <span class="badge" :class="getPaymentMethodClass(item.source)">
                                                        {{item.source}}
                                                    </span>
                        </td>
                        <td>
                          <small class="text-muted">{{item.description || 'N/A'}}</small>
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-xs me-2">
                                                            <span class="avatar-title rounded-circle bg-primary-subtle text-primary">
                                                                {{getAgentInitials(item.names)}}
                                                            </span>
                            </div>
                            <span class="fw-medium">{{item.names || 'N/A'}}</span>
                          </div>
                        </td>
                        <td>
                          <span class="badge bg-success">{{item.status}}</span>
                        </td>
                        <td class="text-end">
                          <div class="d-flex flex-column align-items-end">
                            <strong class="text-success">KES {{numberFormat(item.receiptAmount)}}</strong>
                            <small class="text-muted">{{getTransactionPercentage(item.receiptAmount)}}%</small>
                          </div>
                        </td>
                        <td class="text-center">
                          <button v-if="getRight('PRINT INVOICE')" @click="printBill(item.billNo)"
                                  type="button" class="btn btn-primary btn-sm">
                            <i class="bx bx-printer me-1"></i> Receipt
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="card-footer bg-light" v-if="billDetails.length > 0">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex align-items-center gap-2">
                        <span class="text-muted">Show</span>
                        <select class="form-select form-select-sm" v-model="pageSize" style="width: auto;">
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="500">500</option>
                          <option value="1000">1000</option>
                        </select>
                        <span class="text-muted">entries</span>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <nav aria-label="Page navigation">
                        <ul class="pagination pagination-sm justify-content-end mb-0">
                          <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" @click="prevPage" :disabled="currentPage === 1">
                              <i class="bx bx-chevron-left"></i>
                            </a>
                          </li>
                          <li v-for="page in pagination(currentPage, totalPages, 3)" :key="page"
                              class="page-item" :class="{ active: currentPage === page }">
                            <span v-if="page === '...'" class="page-link">{{ page }}</span>
                            <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                          </li>
                          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">
                              <i class="bx bx-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>

                  <!-- Summary Row -->
                  <div class="row mt-3 pt-3 border-top">
                    <div class="col-12">
                      <div class="d-flex justify-content-between align-items-center">
                        <div>
                          <strong>{{numberFormat(billDetails.length)}} Transactions</strong>
                        </div>
                        <div class="text-end">
                          <div class="text-success"><strong>KES {{numberFormat(totalAmount)}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Zone Performance Analysis -->
                  <div v-if="billDetails.length > 0" class="mt-4 pt-3 border-top bg-light">
                    <div class="row">
                      <div class="col-md-6">
                        <h6 class="mb-3 text-primary">
                          <i class="bx bx-chart-bar me-2"></i>
                          Payment Method Distribution
                        </h6>
                        <div v-for="method in getPaymentMethodStats()" :key="method.name" class="mb-2">
                          <div class="d-flex justify-content-between align-items-center mb-1">
                            <span class="fw-medium">{{ method.name }}</span>
                            <span class="text-success">{{ method.count }} ({{ method.percentage }}%)</span>
                          </div>
                          <div class="progress" style="height: 8px;">
                            <div class="progress-bar" :class="method.colorClass"
                                 :style="`width: ${method.percentage}%`">
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <h6 class="mb-3 text-info">
                          <i class="bx bx-map-pin me-2"></i>
                          Zone Performance Insights
                        </h6>
                        <ul class="list-unstyled">
                          <li class="mb-2">
                            <i class="bx bx-money text-success me-2"></i>
                            Highest transaction: <strong>KES {{ getHighestTransaction() }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-chart-line text-primary me-2"></i>
                            Average per transaction: <strong>KES {{ getAverageTransaction() }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-calendar text-warning me-2"></i>
                            Daily collection average: <strong>KES {{ getDailyAverage() }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-user text-info me-2"></i>
                            Active agents: <strong>{{ getActiveAgents().length }}</strong>
                          </li>
                          <li class="mb-2">
                            <i class="bx bx-time text-danger me-2"></i>
                            Collection period: <strong>{{ getCollectionPeriod() }} days</strong>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!-- Top Agents in Zone -->
                    <div class="row mt-4" v-if="getTopAgents().length > 0">
                      <div class="col-12">
                        <h6 class="mb-3 text-success">
                          <i class="bx bx-award me-2"></i>
                          Top Performing Agents in {{formatZoneName(zone)}}
                        </h6>
                        <div class="row">
                          <div v-for="(agent, index) in getTopAgents().slice(0, 3)" :key="index" class="col-md-4">
                            <div class="card text-center border-success mb-3">
                              <div class="card-body py-3">
                                <div class="avatar-sm mx-auto mb-2">
                                                                    <span class="avatar-title rounded-circle bg-success">
                                                                        {{getAgentInitials(agent.name)}}
                                                                    </span>
                                </div>
                                <h6 class="mb-1">{{agent.name}}</h6>
                                <p class="text-muted mb-1">{{agent.count}} transactions</p>
                                <p class="text-success fw-bold mb-0">KES {{numberFormat(agent.amount)}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col -->
          </div>

          <!-- end row -->
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Developed by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->

  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>

  </body>

</template>

<script>
/* eslint-disable */
import {biller, execute, executeDownload, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import moment from 'moment';

export default {
  name: "ReportsSubCountyZonesDetails",
  components: {NavigationBar},
  data() {
    return {
      loading: false,
      downloading: false,
      downloadText: 'Download Report',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      totalItems:0,
      subCountyName:'',
      subCountyID:'',
      dateTo:'',
      dateFrom:'',
      names:'',
      totalAmount:null,
      billDetails: [],
      billInfo: [],
      zone:'',
      zones:[],
      searchTerm: ''
    };
  },
  watch: {
    pageSize(newPageSize) {
      this.getReceiptsPaginated()
      const totalItems = this.totalItems;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },

    searchTerm(){
      this.currentPage = 1;
      this.getReceiptsPaginated()
    },

    zone(){
      this.currentPage = 1;
      this.getReceiptsPaginated()
    },

    dateFrom(){
      this.currentPage = 1;
      this.getReceiptsPaginated()
    },

    dateTo(){
      this.currentPage = 1;
      this.getReceiptsPaginated()
    }
  },
  computed:{
    startIndex() {
      return (this.currentPage - 1) * this.pageSize;
    },
    endIndex() {
      return this.currentPage * this.pageSize;
    },
  },
  mounted() {
    this.zone = sessionStorage.getItem("zone")
    this.subCountyID = sessionStorage.getItem("subCountyID")
    this.subCountyName = sessionStorage.getItem("subCountyName")
    this.dateTo = sessionStorage.getItem("dateTo")
    this.dateFrom = sessionStorage.getItem("dateFrom")

    this.getZones()
    this.getReceiptsPaginated()
    this.menuAccess()
  },
  methods: {

    // Helper methods for better UX
    formatSubCountyName(name) {
      if (!name || name === 'undefined') return 'Unknown';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    formatZoneName(name) {
      if (!name || name === 'undefined') return 'Unknown Zone';
      return name.toLowerCase().split(' ').map(word =>
          word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
    },

    getZoneInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(word => word.charAt(0)).join('').substring(0, 2).toUpperCase();
    },

    getAgentInitials(name) {
      if (!name) return '?';
      return name.split(' ').map(word => word.charAt(0)).join('').substring(0, 2).toUpperCase();
    },

    getItemNumber(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },

    getAverageTransaction() {
      if (this.billDetails.length === 0) return '0';
      return this.numberFormat(Math.round(this.totalAmount / this.billDetails.length));
    },

    getDailyAverage() {
      const days = this.getCollectionPeriod();
      if (days === 0) return '0';
      return this.numberFormat(Math.round(this.totalAmount / days));
    },

    getCollectionPeriod() {
      if (!this.dateFrom || !this.dateTo) return 0;
      return moment(this.dateTo).diff(moment(this.dateFrom), 'days') + 1;
    },

    getHighestTransaction() {
      if (this.billDetails.length === 0) return '0';
      const highest = Math.max(...this.billDetails.map(item => Number(item.receiptAmount)));
      return this.numberFormat(highest);
    },

    getTransactionPercentage(amount) {
      if (this.totalAmount === 0) return '0.0';
      return ((Number(amount) / this.totalAmount) * 100).toFixed(1);
    },

    getActiveAgents() {
      const agents = [...new Set(this.billDetails.map(item => item.names).filter(name => name && name !== 'N/A'))];
      return agents;
    },

    getTopAgents() {
      const agentStats = {};

      this.billDetails.forEach(item => {
        const agentName = item.names || 'Unknown';
        if (!agentStats[agentName]) {
          agentStats[agentName] = { name: agentName, count: 0, amount: 0 };
        }
        agentStats[agentName].count++;
        agentStats[agentName].amount += Number(item.receiptAmount) || 0;
      });

      return Object.values(agentStats).sort((a, b) => b.amount - a.amount);
    },

    getPaymentMethodClass(method) {
      const classes = {
        'MPESA': 'bg-success',
        'CASH': 'bg-warning text-dark',
        'BANK': 'bg-info',
        'CHEQUE': 'bg-secondary'
      };
      return classes[method?.toUpperCase()] || 'bg-primary';
    },

    getPaymentMethodStats() {
      const methods = {};
      this.billDetails.forEach(item => {
        const method = item.source || 'UNKNOWN';
        methods[method] = (methods[method] || 0) + 1;
      });

      const total = this.billDetails.length;
      const colors = ['bg-success', 'bg-warning', 'bg-info', 'bg-secondary', 'bg-primary'];

      return Object.entries(methods).map(([name, count], index) => ({
        name,
        count,
        percentage: total > 0 ? ((count / total) * 100).toFixed(1) : 0,
        colorClass: colors[index % colors.length]
      })).sort((a, b) => b.count - a.count);
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    refreshData() {
      this.getReceiptsPaginated();
      this.getZones();
    },

    clearFilters() {
      this.searchTerm = '';
      this.currentPage = 1;
    },

    menuAccess(){
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Reports Sub County Zones Details");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,biller)
          .then((res) => {
            // Success
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    getRight(type){
      return getRight(type)
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
      }
      if (end < totalPages) {
        pages.push("...");
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getReceiptsPaginated()
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getReceiptsPaginated()
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getReceiptsPaginated()
      }
    },

    gotTo(route){
      this.$router.push(route);
    },

    formatDate(date) {
      if (!date) return '';
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      })
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    getReceiptsPaginated() {
      this.billDetails.splice(0)
      this.loading = true

      const data = new FormData();
      data.append("function", "getReceiptsPaginated");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.zone)

      execute(data, biller)
          .then((res) => {
            this.loading = false

            if (res.data.success) {
              this.billDetails = res.data.data.billDetails || []

              this.totalItems = res.data.data.summary?.count || 0
              this.totalPages = Math.ceil(this.totalItems / this.pageSize);

              this.totalAmount = this.billDetails.reduce((acc, cur) => {
                let receiptAmount = Number(cur.receiptAmount);
                return acc + receiptAmount;
              }, 0);

            } else {
              console.log("Failed to load transactions:", res.data.message);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("Error loading transactions:", e);
            alert("Failed to load transaction data. Please check your connection and try again.");
          });
    },

    getZones() {
      const data = new FormData();
      data.append("function", "getReceiptedByZonesPaginated");
      data.append("page", this.currentPage);
      data.append("rows_per_page", 1000);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.searchTerm)
      data.append("subCountyID", this.subCountyID)

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.zones = res.data.data.revenueZones || []
            } else {
              console.log("Failed to load zones:", res.data.message);
            }
          })
          .catch((e) => {
            console.error("Error loading zones:", e);
          });
    },

    downloadReceiptsPaginated(){
      this.downloading = true;
      this.downloadText = "Downloading... Please wait";

      const data = new FormData();
      data.append("function", "downloadReceiptsPaginated");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("keyword", this.zone)

      executeDownload(data,biller)
          .then(response => {
            this.downloadText = "Download Report";
            this.downloading = false;

            const link = document.createElement('a');
            link.href = URL.createObjectURL(response.data);
            link.download = `${this.dateFrom}_to_${this.dateTo}_${this.formatZoneName(this.zone)}_transactions.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(e => {
            this.downloadText = "Download Report";
            this.downloading = false;
            console.error("Download error:", e);
            alert("Failed to download report. Please try again.");
          });
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num || 0)
    }
  }
}
</script>

<style scoped>
.card-h-100 {
  height: 100%;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
  font-weight: 600;
}

.bg-primary-subtle {
  background-color: rgba(13, 110, 253, 0.1) !important;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.bx-spin {
  animation: spin 1s linear infinite;
}

.progress {
  background-color: #f3f3f3;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

.zone-selector .form-select {
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
  color: white;
}

.zone-selector .form-select:focus {
  background-color: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
}

.zone-selector .form-select option {
  background-color: #fff;
  color: #333;
}
</style>